module.exports = __webpack_public_path__ + "static/39232a79.product_5.gif";